import { Component, EventEmitter, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PasswordRecoveryService } from '../../../core/services/password-recovery.service';

@Component({
  selector: 'app-change-password-modal',
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.css'
})
export class ChangePasswordModalComponent {
  @Output() close = new EventEmitter<void>();

  oldPassword = signal('');
  newPassword = signal('');
  confirmPassword = signal('');
  showOldPassword = signal(false);
  showNewPassword = signal(false);
  showConfirmPassword = signal(false);


  oldPasswordValue = '';
  newPasswordValue = '';
  confirmPasswordValue = '';

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);
  successMessage = signal<string | null>(null);

  oldPasswordError = signal<string | null>(null);
  newPasswordError = signal<string | null>(null);
  confirmPasswordError = signal<string | null>(null);

  constructor(private passwordRecoveryService: PasswordRecoveryService) { }

  clearFieldErrors(): void {
    this.oldPasswordError.set(null);
    this.newPasswordError.set(null);
    this.confirmPasswordError.set(null);
  }

  setFieldError(field: string, message: string): void {
    switch (field) {
      case 'id':
      case 'oldPassword':
        this.oldPasswordError.set(message);
        break;
      case 'newPassword':
        this.newPasswordError.set(message);
        break;
      case 'confirmPassword':
        this.confirmPasswordError.set(message);
        break;
      default:
        this.errorMessage.set(message);
    }
  }

  onSubmit(): void {
    this.errorMessage.set(null);
    this.clearFieldErrors();

    if (!this.oldPassword() || !this.newPassword() || !this.confirmPassword()) {
      this.errorMessage.set('Пожалуйста, заполните все поля');
      return;
    }

    if (this.newPassword().length < 6) {
      this.newPasswordError.set('Пароль должен содержать минимум 6 символов');
      return;
    }

    if (this.newPassword() !== this.confirmPassword()) {
      this.confirmPasswordError.set('Пароли не совпадают');
      return;
    }

    if (this.oldPassword() === this.newPassword()) {
      this.newPasswordError.set('Новый пароль должен отличаться от старого');
      return;
    }

    this.isLoading.set(true);
    this.successMessage.set(null);

    this.passwordRecoveryService.changePassword({
      oldPassword: this.oldPassword(),
      newPassword: this.newPassword(),
      confirmPassword: this.confirmPassword()
    }).subscribe({
      next: (response: any) => {
        console.log('Password changed:', response);
        this.isLoading.set(false);
        if (response.success) {
          this.successMessage.set('Пароль успешно изменен!');
          setTimeout(() => {
            this.close.emit();
          }, 1500);
        } else {
          if (response.res && response.res.field) {
            const errorMsg = response.res.ru || response.msg || 'Ошибка';
            this.setFieldError(response.res.field, errorMsg);
          } else {
            this.errorMessage.set(response.msg || 'Ошибка при смене пароля');
          }
        }
      },
      error: (error: any) => {
        console.error('Change password error:', error);
        this.isLoading.set(false);
        if (error.error && error.error.res && error.error.res.field) {
          const errorMsg = error.error.res.ru || error.error.msg || 'Ошибка';
          this.setFieldError(error.error.res.field, errorMsg);
        } else {
          this.errorMessage.set('Ошибка при смене пароля. Проверьте старый пароль и попробуйте снова.');
        }
      }
    });
  }

  toggleOldPasswordVisibility(): void {
    this.showOldPassword.update(value => !value);
  }

  toggleNewPasswordVisibility(): void {
    this.showNewPassword.update(value => !value);
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword.update(value => !value);
  }

  onClose(): void {
    this.close.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
